import urlResolver from 'edrolo/utils/URLResolver';
import Request from 'core/api/Request';

export async function uploadActivityBlockResponseFile(
  file,
  activityResponseId,
  blockId
  // trackUploadProgress = (uploadProgressEvent) =>
  //  Math.floor(uploadProgressEvent.percent)
) {
  const url = urlResolver.reverse(
    'api:activities:upload-activity-block-response-file',
    {
      activityResponseId,
      blockId,
    }
  );
  const response = await Request.post(url)
    .attach('file', file)
    //.on('progress', (event) => {
    /* the event is:
      {
        direction: "upload" or "download"
        percent: 0 to 100 // may be missing if file size is unknown
        total: // total file size, may be missing
        loaded: // bytes downloaded or uploaded so far
      }
      */
    // trackUploadProgress(event);
    //})
    .end((err, res) => {
      console.error(err);
      // eslint-disable-next-line no-console
      console.log(res);
    });

  if (response.ok) {
    return response.body;
  }
  throw response;
}
